/* Tirage de cartes IA — logique de l'expérience
 * - 4 étapes : intro → question → choix de 3 cartes → tirage scellé
 * - Les 22 arcanes sont mélangés côté client ; les cartes choisies partent
 *   en propriétés de ligne masquées (_) : visibles commande, pas au checkout.
 * - Ajout panier via /cart/add.js avec verrou, nouvel essai puis filet fiche produit.
 */
(function () {
  if (window._tirageInit) return;
  window._tirageInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    var racine = document.getElementById('tirage');
    var dataEl = document.getElementById('tg-data');
    if (!racine || !dataEl) return;

    var DATA = { produit: {}, fallbackVariantId: '', delaiTexte: '' };
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* défauts ci-dessus */ }

    var ARCANES = [
      'Le Bateleur', 'La Papesse', 'L’Impératrice', 'L’Empereur', 'Le Pape',
      'L’Amoureux', 'Le Chariot', 'La Justice', 'L’Hermite', 'La Roue de Fortune',
      'La Force', 'Le Pendu', 'L’Arcane sans nom', 'La Tempérance', 'Le Diable',
      'La Maison Dieu', 'L’Étoile', 'La Lune', 'Le Soleil', 'Le Jugement',
      'Le Monde', 'Le Mat'
    ];

    var etat = { prenom: '', question: '', paquet: [], choisies: [], verrou: false, varianteChoisie: null };

    // ------------------------------------------------------------ utilitaires
    function $(sel) { return racine.querySelector(sel); }
    function $$(sel) { return Array.prototype.slice.call(racine.querySelectorAll(sel)); }

    function melanger(liste) {
      var copie = liste.slice();
      for (var i = copie.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = copie[i]; copie[i] = copie[j]; copie[j] = tmp;
      }
      return copie;
    }

    function montrer(nom) {
      $$('.tg-etape').forEach(function (el) {
        el.hidden = el.getAttribute('data-tg-etape') !== nom;
      });
      var haut = racine.getBoundingClientRect().top + window.pageYOffset - 10;
      window.scrollTo({ top: haut > 0 ? haut : 0, behavior: 'smooth' });
    }

    // ------------------------------------------------------------ étape intro
    var btnCommencer = $('[data-tg-action="commencer"]');
    if (btnCommencer) btnCommencer.addEventListener('click', function () { montrer('question'); });

    // ------------------------------------------------------------ étape question
    var champQuestion = $('#tg-champ-question');
    var champPrenom = $('#tg-champ-prenom');
    var erreurQuestion = $('[data-tg-erreur]');

    $$('[data-tg-exemple]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (champQuestion) {
          champQuestion.value = btn.textContent.trim();
          champQuestion.focus();
        }
      });
    });

    var btnValider = $('[data-tg-action="valider-question"]');
    if (btnValider) btnValider.addEventListener('click', function () {
      var question = champQuestion ? champQuestion.value.trim() : '';
      var prenom = champPrenom ? champPrenom.value.trim() : '';
      var ok = question.length >= 10 && prenom.length >= 2;
      if (erreurQuestion) erreurQuestion.hidden = ok;
      if (!ok) return;
      etat.question = question;
      etat.prenom = prenom;
      etat.paquet = melanger(ARCANES);
      etat.choisies = [];
      var spanPrenom = $('[data-tg-prenom]');
      var virgule = $('[data-tg-prenom-virgule]');
      if (spanPrenom) spanPrenom.textContent = prenom;
      if (virgule) virgule.hidden = false;
      montrer('cartes');
    });

    // ------------------------------------------------------------ étape tirage
    var fentes = $$('[data-tg-fente]');
    var compteEl = $('[data-tg-compte]');
    var plurielEl = $('[data-tg-pluriel]');

    $$('[data-tg-carte]').forEach(function (carte, index) {
      carte.addEventListener('click', function () {
        if (etat.choisies.length >= 3 || carte.classList.contains('est-choisie')) return;
        etat.choisies.push(etat.paquet[index]);
        carte.classList.add('est-choisie');
        carte.setAttribute('aria-pressed', 'true');

        var fente = fentes[etat.choisies.length - 1];
        if (fente) {
          var img = carte.querySelector('img');
          if (img) {
            var copie = img.cloneNode(false);
            copie.alt = '';
            fente.appendChild(copie);
          }
          fente.classList.add('est-remplie');
        }
        if (compteEl) compteEl.textContent = String(etat.choisies.length);
        if (plurielEl) plurielEl.hidden = etat.choisies.length < 2;

        setTimeout(function () { carte.classList.add('est-partie'); }, 220);

        if (etat.choisies.length === 3) {
          setTimeout(function () {
            var rappel = $('[data-tg-question]');
            if (rappel) rappel.textContent = '« ' + etat.question + ' »';
            montrer('scelle');
          }, 750);
        }
      });
    });

    // ------------------------------------------------------------ formules
    var offres = $$('[data-tg-offre]');
    var prixEl = $('[data-tg-prix]');

    function choisirOffre(btn) {
      var id = btn.getAttribute('data-variant');
      offres.forEach(function (o) {
        o.classList.toggle('est-choisie', o.getAttribute('data-variant') === id);
      });
      etat.varianteChoisie = parseInt(id, 10) || null;
      var prix = btn.getAttribute('data-prix');
      if (prixEl && prix) prixEl.textContent = prix;
    }

    offres.forEach(function (btn) {
      btn.addEventListener('click', function () { choisirOffre(btn); });
    });
    (function () {
      var initiale = null;
      offres.forEach(function (o) {
        if (!initiale && o.classList.contains('est-choisie') && !o.disabled) initiale = o;
      });
      if (!initiale) offres.forEach(function (o) { if (!initiale && !o.disabled) initiale = o; });
      if (initiale) choisirOffre(initiale);
    })();

    // ------------------------------------------------------------ étape scellé
    function variantId() {
      if (etat.varianteChoisie) return etat.varianteChoisie;
      if (DATA.produit && DATA.produit.variantId) return DATA.produit.variantId;
      var secours = parseInt(DATA.fallbackVariantId, 10);
      return isNaN(secours) ? null : secours;
    }

    function afficherErreurPanier(visible) {
      var el = $('[data-tg-erreur-panier]');
      if (el) el.hidden = !visible;
    }

    function allerAuFilet() {
      if (DATA.produit && DATA.produit.url) {
        window.location.href = DATA.produit.url;
      } else {
        afficherErreurPanier(true);
      }
    }

    function ajouterAuPanier(nouvelEssai) {
      var id = variantId();
      if (!id) { allerAuFilet(); return; }
      var jour = new Date();
      var dateTexte = jour.toLocaleDateString('fr-FR');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: id,
            quantity: 1,
            properties: {
              'Prénom': etat.prenom,
              'Votre question': etat.question,
              '_Cartes tirées': etat.choisies.join(' · '),
              '_Tirage du': dateTexte
            }
          }]
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('statut ' + r.status);
        return r.json(); // le rate-limit Shopify renvoie du HTML : le parse échoue et part en catch
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function () {
        if (!nouvelEssai) {
          setTimeout(function () { ajouterAuPanier(true); }, 1400);
        } else {
          etat.verrou = false;
          var btn = $('[data-tg-action="commander"]');
          if (btn) { btn.disabled = false; btn.textContent = 'Recevoir ma lecture complète'; }
          afficherErreurPanier(true);
        }
      });
    }

    var btnCommander = $('[data-tg-action="commander"]');
    if (btnCommander) btnCommander.addEventListener('click', function () {
      if (etat.verrou) return;
      etat.verrou = true;
      afficherErreurPanier(false);
      btnCommander.disabled = true;
      btnCommander.textContent = 'Un instant…';
      ajouterAuPanier(false);
    });

    var btnRecommencer = $('[data-tg-action="recommencer"]');
    if (btnRecommencer) btnRecommencer.addEventListener('click', function () {
      etat.paquet = melanger(ARCANES);
      etat.choisies = [];
      etat.verrou = false;
      $$('[data-tg-carte]').forEach(function (carte) {
        carte.classList.remove('est-choisie', 'est-partie');
        carte.removeAttribute('aria-pressed');
      });
      fentes.forEach(function (fente) {
        fente.classList.remove('est-remplie');
        while (fente.firstChild) fente.removeChild(fente.firstChild);
      });
      if (compteEl) compteEl.textContent = '0';
      if (plurielEl) plurielEl.hidden = true;
      if (btnCommander) { btnCommander.disabled = false; btnCommander.textContent = 'Recevoir ma lecture complète'; }
      afficherErreurPanier(false);
      montrer('cartes');
    });
  });
})();
